import posthog from "posthog-js";
import { useEffect } from "react";
export const useTrackUserByWallet = (wallet, options) => {
    const { userProperties, eventProperties, getChainName } = options || {};
    const account = wallet.useAccount();
    const chainId = wallet.useSupportedChainId();
    const { name: walletName } = wallet.useWalletConfig();
    useEffect(() => {
        const properties = {
            chainId,
            walletName,
        };
        if (getChainName && chainId) {
            properties.chainName = getChainName(chainId);
        }
        posthog.identify(account, {
            wallet_address: account,
            ...userProperties,
        });
        posthog.register({
            ...properties,
            ...eventProperties,
        });
        return () => {
            posthog.reset();
        };
    }, [account, chainId, walletName]);
};
